import { AdminArenaConfiguration } from "../../app-bootstrap/config-interfaces/casino-startup.configurations";
import { createStatementsDefinition } from './create-statements-definition';
import {HOME_PAGE_ARENA, LIVE_CASINO_ARENA_NAME, NEW_LIVE_CASINO_ARENA_NAME} from '../arenas/arena-consts';
import {Check} from "@sparkware/app-utils";

enum List_Type {
  Swipers = "swipers",
  Grids = "grids",
  PopularTables = "popularTables"
}

export function injectAdminArenas(
  originalConfigData: any,
  adminArenaConfigData: { [key: string]: AdminArenaConfiguration }
): void {

  if (originalConfigData.homePage) {
    originalConfigData.homePage.gamesLists = getAdminArenaLists(
      adminArenaConfigData,
      HOME_PAGE_ARENA,
      List_Type.Swipers
    );
  }

  if (originalConfigData.arenas) {
    Object.keys(originalConfigData.arenas).forEach(arenaKey => {
      if (arenaKey === LIVE_CASINO_ARENA_NAME || arenaKey === NEW_LIVE_CASINO_ARENA_NAME) {
        originalConfigData.arenas[arenaKey].popularTables = getAdminArenaLists(
          adminArenaConfigData,
          arenaKey,
          List_Type.PopularTables
        );
      }
      else {
        originalConfigData.arenas[arenaKey].swiperGamesList = getAdminArenaLists(
          adminArenaConfigData,
          arenaKey,
          List_Type.Swipers
        );

        originalConfigData.arenas[arenaKey].allGamesGrid = getAdminArenaLists(
          adminArenaConfigData,
          arenaKey,
          List_Type.Grids
        );
      }
    });
  }
}

function getAdminArenaLists(
  adminArenaConfigData: { [key: string]: AdminArenaConfiguration },
  arenaKey: string,
  listType: string
) {
  let adminLists: unknown[] = [];
  if (adminArenaConfigData[arenaKey] && adminArenaConfigData[arenaKey].lists[listType]) {
    adminArenaConfigData[arenaKey].lists[listType].forEach(list => {
      let currentList = Object.assign({}, list.Metadata);

      currentList.display = Check.isNullOrUndefined(list.Metadata.display) ? true : list.Metadata.display;

      let segmentation = createStatementsDefinition(list.SubLists);
      currentList.gamesId = {};
      currentList.gamesId.defaultValue = segmentation.defaultValue;
      currentList.gamesId.statements = segmentation.statements;

      adminLists.push(currentList);
    });
  }

  return adminLists;
}
